import { Helper } from "../core/util/helper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { Config } from "../core/config/config";
import { EntityServiceReportTime } from "./serviceReportTimesInGrid";
import { EntityServiceReportMaterial } from "./serviceReportMaterialsInGrid";
import { EntityServiceReportCashExpenses } from "./serviceReportCashExpensesInGrid";
import { EntityServiceReportAccomplishedWork } from "./serviceReportCompletionGrid";
import { Entity } from "../core/components/commonApp";
import { StringKeyDictionary } from "../commonInterfaces";

export class ServiceReportUtil {
    static _utcOffsetInMinutes: number;
    public static calculateSummaryCashExpenses(cashExpenses: Array<EntityServiceReportCashExpenses>) {
        let result = {
            Count: cashExpenses.length, Sum: 0
        }

        for (var cashExpense of cashExpenses) {
            result.Sum += cashExpense.CurrIntSumme;
        }

        return result;
    }

    public static calculateSummaryMaterials(materials: Array<EntityServiceReportMaterial>) {
        let result = {
            Count: materials.length, Sum: 0
        }

        for (var material of materials) {
            result.Sum += material.Gpreis;
        }

        return result;
    }

    public static calculateSummaryHours(times: Array<EntityServiceReportTime>) {
        let result = {
            TravelHours: 0, WaitingHours: 0, WorkingHours: 0
        }

        for (var time of times) {
            if (time.Zeittyp == 2 || time.Zeittyp == 6 || time.Zeittyp == 7 || time.Zeittyp == 8) {
                result.WorkingHours += (time.Zbis - time.Zvon - ServiceReportUtil.calculateBreak(time, times));
            }
            if (time.Zeittyp == 1 || time.Zeittyp == 3 || time.Zeittyp == 9) {
                result.TravelHours += (time.Zbis - time.Zvon - ServiceReportUtil.calculateBreak(time, times));
            }
            if (time.Zeittyp == 4) {
                result.WaitingHours += (time.Zbis - time.Zvon - ServiceReportUtil.calculateBreak(time, times));
            }
        }

        return result;
    }

    public static calculateBreak(time: EntityServiceReportTime, times: Array<EntityServiceReportTime>): number {
        let result = 0;
        if (time.Zeittyp == 5) {
            return time.Zbis - time.Zvon;
        }
        else {
            for (var breakTime of times.filter(x => (x.Zeittyp == 5) && x.Datum == time.Datum)) {
                {
                    if ((breakTime.Zvon < time.Zbis && breakTime.Zvon >= time.Zvon)
                        || (breakTime.Zbis <= time.Zbis && breakTime.Zbis > time.Zvon)
                        || (breakTime.Zvon <= time.Zvon && breakTime.Zbis >= time.Zbis)) {
                        result += (Math.min(time.Zbis, breakTime.Zbis) - Math.max(time.Zvon, breakTime.Zvon));
                    }
                }
            }
        }

        return result;
    }
    public static _getUtcOffset = (adrnr: string): Promise<boolean> => {
        return new Promise<boolean>((resolve, reject) => {
            HTTPService.get<JsonResultClass>("TimeZoneLookup/GetUTCOffsetByAdrNr", {
                adrNr: adrnr
            }).then(async (result: JsonResultClass) => {
                ServiceReportUtil._utcOffsetInMinutes = result.Data;
                resolve(true);
            }, (error) => {
                console.error(error);
                resolve(false);
            });
        });
    }
    public static async createServiceReportTime(canRead: boolean, canWrite: boolean, adrnr: string, pindex: number, projnr: string, active: boolean): Promise<EntityServiceReportTime> {
        let today = new Date();
        let getOffset = await this._getUtcOffset(adrnr);
        if (getOffset) {
            return {
                IsNew: true,
                Datum: kendo.parseDate(today.getFullYear() + "-" + Helper.getTwoDigits(today.getMonth() + 1) + "-" + Helper.getTwoDigits(today.getDate()) + "T00:00:00"),
                Zvon: 0,
                Zbis: 0,
                Utcoffset: this._utcOffsetInMinutes,
                UtcoffsetZBis: this._utcOffsetInMinutes,
                Bemerkung: "",
                Isguid: "{" + kendo.guid() + "}",
                Dgfzeile: null,
                Zeittyp: null,
                Feiertagart: null,
                Changed: false,
                RecordRight: { CanRead: canRead, CanWrite: canWrite },
                IndividualFields: {},
                IsWatchable: false,
                IsWatched: false,
                Timetypeisguid: null,
                Pindex: pindex,
                Projnr: projnr
            }
        } else {
            return {
                IsNew: true,
                Datum: kendo.parseDate(today.getFullYear() + "-" + Helper.getTwoDigits(today.getMonth() + 1) + "-" + Helper.getTwoDigits(today.getDate()) + "T00:00:00"),
                Zvon: 0,
                Zbis: 0,
                Utcoffset: 0,
                UtcoffsetZBis: 0,
                Bemerkung: "",
                Isguid: "{" + kendo.guid() + "}",
                Dgfzeile: null,
                Zeittyp: null,
                Feiertagart: null,
                Changed: false,
                RecordRight: { CanRead: canRead, CanWrite: canWrite },
                IndividualFields: {},
                IsWatchable: false,
                IsWatched: false,
                Timetypeisguid: null,
                Pindex: pindex,
                Projnr: projnr
            }
        }
    }

    public static createServiceReportTimeHorizontal(canRead: boolean, canWrite: boolean, currentTimes: Array<EntityServiceReportTimeHorizontal> = null): EntityServiceReportTimeHorizontal {
        // Nächste dgfzeile ermitteln
        let dgfzeile = 1;
        if (currentTimes !== null && currentTimes.length > 0) {
            let sortedTimes = currentTimes.sort((n1, n2) => {
                if (n1.Dgfzeile > n2.Dgfzeile) {
                    return 1;
                }

                if (n1.Dgfzeile < n2.Dgfzeile) {
                    return -1;
                }

                return 0;
            });
            dgfzeile = sortedTimes[sortedTimes.length - 1].Dgfzeile + 1;
        }

        let today = new Date();

        return {
            Isguid: "{" + kendo.guid() + "}",
            IsNew: true,
            Datum: today.getFullYear() + "-" + Helper.getTwoDigits(today.getMonth() + 1) + "-" + Helper.getTwoDigits(today.getDate()) + "T00:00:00",
            Dgfzeile: dgfzeile,
            Bemerkung: "",
            Feiertagart: null,
            FeiertagartAsString: null,
            Changed: false,
            Type_1_Zvon: null, Type_1_ZvonAsString: null, Type_1_Zbis: null, Type_1_ZbisAsString: null, Type_1_Isguid: null,
            Type_2_Zvon: null, Type_2_ZvonAsString: null, Type_2_Zbis: null, Type_2_ZbisAsString: null, Type_2_Isguid: null,
            Type_3_Zvon: null, Type_3_ZvonAsString: null, Type_3_Zbis: null, Type_3_ZbisAsString: null, Type_3_Isguid: null,
            Type_4_Zvon: null, Type_4_ZvonAsString: null, Type_4_Zbis: null, Type_4_ZbisAsString: null, Type_4_Isguid: null,
            Type_5_Zvon: null, Type_5_ZvonAsString: null, Type_5_Zbis: null, Type_5_ZbisAsString: null, Type_5_Isguid: null,
            Type_6_Zvon: null, Type_6_ZvonAsString: null, Type_6_Zbis: null, Type_6_ZbisAsString: null, Type_6_Isguid: null,
            Type_7_Zvon: null, Type_7_ZvonAsString: null, Type_7_Zbis: null, Type_7_ZbisAsString: null, Type_7_Isguid: null,
            Type_8_Zvon: null, Type_8_ZvonAsString: null, Type_8_Zbis: null, Type_8_ZbisAsString: null, Type_8_Isguid: null,
            RecordRight: { CanRead: canRead, CanWrite: canWrite },
            IndividualFields: {},
            IsWatchable: false,
            IsWatched: false
        }
    }

    public static convertToHorizontal(data: Array<EntityServiceReportTime>): Array<EntityServiceReportTimeHorizontal> {
        let result: Array<EntityServiceReportTimeHorizontal> = [];

        if (data.length == 0)
            return result;

        // Sortieren nach Dgfzeile, Zeittyp
        let sortedTimesVert = data.sort((n1, n2) => {
            if (n1.Dgfzeile > n2.Dgfzeile) {
                return 1;
            }
            if (n1.Dgfzeile < n2.Dgfzeile) {
                return -1;
            }
            if (n1.Zeittyp > n2.Zeittyp) {
                return 1;
            }
            if (n1.Zeittyp < n2.Zeittyp) {
                return -1;
            }
            return 0;
        });

        let currDgfzeile = sortedTimesVert[0].Dgfzeile;
        let currTimeHoriz = this.createServiceReportTimeHorizontal(sortedTimesVert[0].RecordRight.CanRead, sortedTimesVert[0].RecordRight.CanWrite);
        currTimeHoriz.Dgfzeile = currDgfzeile;
        currTimeHoriz.IsNew = false;
        currTimeHoriz.Changed = sortedTimesVert[0].Changed;
        currTimeHoriz.Datum = sortedTimesVert[0].Datum;
        currTimeHoriz.Feiertagart = sortedTimesVert[0].Feiertagart;
        currTimeHoriz.Bemerkung = sortedTimesVert[0].Bemerkung;
        currTimeHoriz.IndividualFields = sortedTimesVert[0].IndividualFields;
        for (var timeVert of sortedTimesVert) {
            if (timeVert.Dgfzeile != currDgfzeile) {
                result.push(currTimeHoriz);
                currDgfzeile = timeVert.Dgfzeile;
                currTimeHoriz = this.createServiceReportTimeHorizontal(timeVert.RecordRight.CanRead, timeVert.RecordRight.CanWrite);
                currTimeHoriz.Dgfzeile = currDgfzeile;
                currTimeHoriz.IsNew = false;
                currTimeHoriz.Changed = timeVert.Changed;
                currTimeHoriz.Datum = timeVert.Datum;
                currTimeHoriz.Feiertagart = timeVert.Feiertagart;
                currTimeHoriz.Bemerkung = timeVert.Bemerkung;
                currTimeHoriz.IndividualFields = timeVert.IndividualFields;
            }
            let propertyPrefix = "Type_" + timeVert.Zeittyp + "_";
            currTimeHoriz[propertyPrefix + "Isguid"] = timeVert.Isguid;
            currTimeHoriz[propertyPrefix + "Zvon"] = timeVert.Zvon;
            currTimeHoriz[propertyPrefix + "Zbis"] = timeVert.Zbis;
        }
        result.push(currTimeHoriz);

        return result;
    }

    public static convertToVertical(data: Array<EntityServiceReportTimeHorizontal>): Array<EntityServiceReportTime> {
        let entityServiceReportTime: Array<EntityServiceReportTime> = [];

        if (data.length == 0)
            return entityServiceReportTime;

        for (var timeHoriz of data) {
            for (let i = 1; i < 9; i++) {
                let propertyPrefix = "Type_" + i + "_";
                if (timeHoriz[propertyPrefix + "Zvon"] !== null && timeHoriz[propertyPrefix + "Zbis"] !== null) {
                    let createTimeEntity = this.createServiceReportTime(timeHoriz.RecordRight.CanRead, timeHoriz.RecordRight.CanWrite, null, null, null, false).then(result => {
                        let currTimeVert = result;
                        currTimeVert.Zeittyp = i;
                        currTimeVert.Zvon = timeHoriz[propertyPrefix + "Zvon"];
                        currTimeVert.Zbis = timeHoriz[propertyPrefix + "Zbis"];
                        currTimeVert.IsNew = timeHoriz.IsNew;
                        currTimeVert.Changed = timeHoriz.Changed;
                        currTimeVert.Datum = kendo.parseDate(timeHoriz.Datum.toString());
                        currTimeVert.Dgfzeile = timeHoriz.Dgfzeile;
                        currTimeVert.Feiertagart = timeHoriz.Feiertagart;
                        currTimeVert.Bemerkung = timeHoriz.Bemerkung;
                        currTimeVert.IndividualFields = timeHoriz.IndividualFields;
                        entityServiceReportTime.push(currTimeVert);
                    });

                }
            }
        }
        return entityServiceReportTime;
    }


    public static groupTimesPerDay(times: Array<EntityServiceReportTime>): StringKeyDictionary<Array<EntityServiceReportTime>> {
        const result = {};
        if (times.length > 0) {
            for (let i = 0; i < times.length; i++) {
                let dateString;
                let tmp = times[i].Datum
                if (tmp instanceof Date) {
                    dateString = Helper.dates.getISODateString(tmp);
                } else {
                    dateString = times[i].Datum;
                }

                if (!result[dateString]) {
                    result[dateString] = [];
                }
                result[dateString].push(times[i]);
            }

        }
        return result;
    }

    public static getAlreadyDistributedTimes(accomplished: Array<EntityServiceReportAccomplishedWork>): StringKeyDictionary<{ date: string; minutes: number; }> {
        const distCache: StringKeyDictionary<{ date: string; minutes: number; }> = {};
        for (let i = 0; i < accomplished.length; i++) {
            const item = accomplished[i];
            let key = item.Datum;
            //...
            //notwändig nach "new"
            if ((key as any) instanceof Date) {
                key = Helper.dates.getISODateString((key as any) as Date);
                item.Datum = key;
            }
            if (!distCache[key]) {
                distCache[key] = {
                    date: key,
                    minutes: 0
                };
            }
            distCache[key].minutes += item.Minuten;
        }
        return distCache;
    }

    public static getDistributableTimes(groupedTimes: StringKeyDictionary<Array<EntityServiceReportTime>>, distributable: StringKeyDictionary<{ date: string; minutes: number; }>): Array<EntityServiceReportDistributableHours> {
        const availableCache: Array<EntityServiceReportDistributableHours> = [];
        for (let d in groupedTimes) {
            const converted = ServiceReportUtil.calculateSummaryHours(groupedTimes[d]);
            const newDist: EntityServiceReportDistributableHours = {
                Date: kendo.parseDate(d),
                DateAsString: d,
                TotalMinutes: converted.WorkingHours,
                TotalAsString: Helper.dates.fromMinutesSinceMidnight(converted.WorkingHours),
                DistMinutes: Helper.hasValue(distributable[d]) ? distributable[d].minutes : 0,
                DistAsString: Helper.hasValue(distributable[d]) ? Helper.dates.fromMinutesSinceMidnight(distributable[d].minutes) : "00:00"
            };
            newDist.RemainingMinutes = newDist.TotalMinutes - newDist.DistMinutes;
            newDist.RemainingAsString = Helper.dates.fromMinutesSinceMidnight(newDist.RemainingMinutes);
            availableCache.push(newDist);
        }
        return availableCache;
    }

    public static validateAccomplishedWorks(times: Array<EntityServiceReportTime>, accomplished: Array<EntityServiceReportAccomplishedWork>): ServiceReportAccomplishedWorkValidationResult {
        const result: ServiceReportAccomplishedWorkValidationResult = { valid: true };
        const groupedTimes = ServiceReportUtil.groupTimesPerDay(times);
        const alreadyDistributed = ServiceReportUtil.getAlreadyDistributedTimes(accomplished);
        const availableToDistribute = ServiceReportUtil.getDistributableTimes(groupedTimes, alreadyDistributed);
        if (Config.user.activateLbarbeitValidation) {
            for (let i = 0; i < accomplished.length; i++) {
                let missing = true;
                for (let j = 0; j < availableToDistribute.length; j++) {
                    if (availableToDistribute[j].DateAsString === accomplished[i].Datum) {
                        missing = false;
                        break;
                    }
                }

                if (missing && accomplished[i].Minuten > 0) {
                    result.valid = false;
                    result.errorDate = accomplished[i].Datum;
                    result.availableMinutes = 0;
                    result.minutesOver = alreadyDistributed[accomplished[i].Datum].minutes;

                    return result;
                }
            }

            for (let i = 0; i < availableToDistribute.length; i++) {
                if (availableToDistribute[i].RemainingMinutes < 0) {
                    result.valid = false;
                    result.errorDate = availableToDistribute[i].DateAsString;
                    result.availableMinutes = availableToDistribute[i].TotalMinutes;
                    result.minutesOver = -availableToDistribute[i].RemainingMinutes;

                    return result;
                }
            }
        }


        return result;
    }

    //wenn die Übersetzung geändert wird, muss man diese Funktion auch anpassen...
    public static formatAccomplishedValidationErrorMessage(message: string, result: ServiceReportAccomplishedWorkValidationResult): string {
        let msg = message;

        const totalParts = Helper.dates.fromMinutesSinceMidnight(result.availableMinutes).split(":");
        const overParts = Helper.dates.fromMinutesSinceMidnight(result.minutesOver).split(":");

        msg = msg
            .replace("{hours}", parseInt(totalParts[0], 10).toString())
            .replace("{minutes}", parseInt(totalParts[1], 10).toString())
            .replace("{date}", Helper.dates.toString(kendo.parseDate(result.errorDate)))
            .replace("{nHours}", parseInt(overParts[0], 10).toString())
            .replace("{nMinutes}", parseInt(overParts[1], 10).toString());

        return msg;
    }
}

interface ServiceReportAccomplishedWorkValidationResult {
    valid: boolean;
    errorDate?: string;
    availableMinutes?: number;
    minutesOver?: number;
}

export interface EntityServiceReportDistributableHours {
    Date?: Date;
    DateAsString?: string;
    TotalAsString?: string;
    TotalMinutes?: number;
    DistAsString?: string;
    DistMinutes?: number;
    RemainingAsString?: string;
    RemainingMinutes?: number;
}

export interface EntityServiceReportTimeHorizontal extends Entity {
    Isguid: string;
    Datum: string | Date;
    Dgfzeile: number;
    Bemerkung: string;
    Feiertagart: number;
    FeiertagartAsString: string;
    Changed: boolean;
    Type_1_Zvon: Number;
    Type_1_ZvonAsString: string;
    Type_1_Zbis: number;
    Type_1_ZbisAsString: string;
    Type_1_Isguid: string;
    Type_2_Zvon: Number;
    Type_2_ZvonAsString: string;
    Type_2_Zbis: number;
    Type_2_ZbisAsString: string;
    Type_2_Isguid: string;
    Type_3_Zvon: Number;
    Type_3_ZvonAsString: string;
    Type_3_Zbis: number;
    Type_3_ZbisAsString: string;
    Type_3_Isguid: string;
    Type_4_Zvon: Number;
    Type_4_ZvonAsString: string;
    Type_4_Zbis: number;
    Type_4_ZbisAsString: string;
    Type_4_Isguid: string;
    Type_5_Zvon: Number;
    Type_5_ZvonAsString: string;
    Type_5_Zbis: number;
    Type_5_ZbisAsString: string;
    Type_5_Isguid: string;
    Type_6_Zvon: Number;
    Type_6_ZvonAsString: string;
    Type_6_Zbis: number;
    Type_6_ZbisAsString: string;
    Type_6_Isguid: string;
    Type_7_Zvon: Number;
    Type_7_ZvonAsString: string;
    Type_7_Zbis: number;
    Type_7_ZbisAsString: string;
    Type_7_Isguid: string;
    Type_8_Zvon: Number;
    Type_8_ZvonAsString: string;
    Type_8_Zbis: number;
    Type_8_ZbisAsString: string;
    Type_8_Isguid: string;
}